import config from "../config";
// import { getActions, getTypes, getType } from '../helpers/crudActions'
import { getType } from "../helpers/crudActions";
import HttpClient from "../helpers/httpclient";

const OBJECT_GENERATE_TOKEN = getType("OBJECT_GENERATE_TOKEN", "SHARED_OBJECTS");
export const OBJECT_GENERATE_TOKEN_PENDING = getType("OBJECT_GENERATE_TOKEN_PENDING", "SHARED_OBJECTS");
export const OBJECT_GENERATE_TOKEN_REJECTED = getType("OBJECT_GENERATE_TOKEN_REJECTED", "SHARED_OBJECTS");
export const OBJECT_GENERATE_TOKEN_FULFILLED = getType("OBJECT_GENERATE_TOKEN_FULFILLED", "SHARED_OBJECTS");

export default {
  OBJECT_GENERATE_TOKEN,
  OBJECT_GENERATE_TOKEN_PENDING,
  OBJECT_GENERATE_TOKEN_REJECTED,
  OBJECT_GENERATE_TOKEN_FULFILLED,
  generateToken(id, type, user) {
    return {
      type: OBJECT_GENERATE_TOKEN,
      // Keep `user` during the compatibility window so cached/new frontend
      // bundles can still talk to the pre-lifecycle backend. The lifecycle
      // backend intentionally ignores it and trusts only the session owner.
      payload: HttpClient.post(`${config.api}/shared-objects/generate`, { id, type, user }),
    };
  },
};
